module.exports = __webpack_public_path__ + "img/order_success_animation_frame_2.9478286f.png";